export const SearchParams = {
  postId: 'postId',
};
